module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('PageHeader', {
    attrs: {
      "title": "File Importer",
      "subtitle": "Import a PDF or CLEX file to convert into Micro Notes"
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "main-content container-fluid xs-pt-0"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('PanelBody', [_vm._c('div', {
    staticClass: "row xs-mb-50 xs-mt-20"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-sm-4 col-xl-2 xs-pt-0 sm-pt-10"
  }, [_vm._c('span', {}, [_vm._v("Type of file to import:")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-8 col-xl-4 xs-pt-10 sm-pt-0"
  }, [_vm._c('button', {
    staticClass: "btn btn-xl xs-mr-10",
    class: _vm.importType === 'pdf' ? 'btn-outline-primary' : 'btn-outline-default',
    on: {
      "click": function($event) {
        _vm.importType = 'pdf'
      }
    }
  }, [_vm._c('i', {
    staticClass: "far",
    class: _vm.importType === 'pdf' ? 'fa-check-square' : 'fa-square'
  }), _vm._v(" Import a PDF")]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-xl",
    class: _vm.importType === 'clex' ? 'btn-outline-primary' : 'btn-outline-default',
    on: {
      "click": function($event) {
        _vm.importType = 'clex'
      }
    }
  }, [_vm._c('i', {
    staticClass: "far",
    class: _vm.importType === 'clex' ? 'fa-check-square' : 'fa-square'
  }), _vm._v(" Import CLEX file")]), _vm._v(" "), _vm._c('span', {
    staticClass: "text-primary import-other-link",
    style: (_vm.showOther ? 'text-decoration:underline;' : ''),
    on: {
      "click": _vm.toggleOther
    }
  }, [_vm._v("Import other file types")]), _vm._v(" "), (_vm.showOther) ? _vm._c('div', {
    staticClass: "import-other"
  }, [_vm._c('p', [_vm._v("\n                    Upload other file types to Google Drive to convert to PDF."), _vm._c('br'), _vm._v(" "), _vm._c('a', {
    attrs: {
      "href": "https://support.google.com/drive/answer/37603?hl=en",
      "target": "_blank"
    }
  }, [_vm._v("Click here to see what types of files can be uploaded to Google Drive.")])]), _vm._v(" "), _vm._c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "https://drive.google.com/drive/my-drive",
      "target": "_blank"
    }
  }, [_vm._v("Go to my Google Drive")]), _vm._v(" "), _vm._c('p', {
    staticClass: "text-muted xs-mb-0 xs-mt-10"
  }, [_vm._v("Note: You will need to log in to your Google account.")])]) : _vm._e()])]), _vm._v(" "), (_vm.importType === 'pdf') ? _vm._c('div', {
    staticClass: "row"
  }, [(_vm.subjects && _vm.subjects.length && !_vm.newSubjectTitle) ? _vm._c('div', {
    staticClass: "col-md-6"
  }, [_vm._c('label', {
    attrs: {
      "for": "lectureNoteSubject"
    }
  }, [_vm._v("Place in existing subject")]), _vm._v(" "), _vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSubjectTitle),
      expression: "selectedSubjectTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "lectureNoteSubject"
    },
    on: {
      "change": function($event) {
        _vm.selectedSubjectTitle = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_vm._c('option'), _vm._v(" "), _vm._l((_vm.subjects), function(subject) {
    return _vm._c('option', {
      domProps: {
        "value": subject.title
      }
    }, [_vm._v(_vm._s(subject.title))])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "col-md-6"
  }, [_vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('label', {
    attrs: {
      "for": "newLectureNoteSubject"
    }
  }, [(_vm.subjects && _vm.subjects.length && !_vm.newSubjectTitle) ? _vm._c('span', [_vm._v("Or ")]) : _vm._e(), _vm._v("Create a new subject")]), _vm._v(" "), _vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSubjectTitle),
      expression: "newSubjectTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "newLectureNoteSubject",
      "placeholder": "Subject Name"
    },
    domProps: {
      "value": _vm._s(_vm.newSubjectTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSubjectTitle = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.showCourses) ? _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-6"
  }, [_vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('label', {
    attrs: {
      "for": "courses"
    }
  }, [_vm._v("Select a Course")]), _vm._v(" "), _vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.course_id),
      expression: "course_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "courses"
    },
    on: {
      "change": function($event) {
        _vm.course_id = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_vm._c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-- Select Course --")]), _vm._v(" "), _vm._l((_vm.allCourses), function(course) {
    return _vm._c('option', {
      domProps: {
        "value": course.id
      }
    }, [_vm._v(_vm._s(course.name))])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.validSubject && _vm.importType === 'pdf') ? _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-3"
  }, [_vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('label', {
    attrs: {
      "for": "newLectureNoteFirstPage"
    }
  }, [_vm._v("First PDF Page to Import")]), _vm._v(" "), _vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newLectureNoteFirstPage),
      expression: "newLectureNoteFirstPage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "id": "newLectureNoteFirstPage",
      "placeholder": "Optional"
    },
    domProps: {
      "value": _vm._s(_vm.newLectureNoteFirstPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLectureNoteFirstPage = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-md-3"
  }, [_vm._c('div', {
    staticClass: "form-group"
  }, [_vm._c('label', {
    attrs: {
      "for": "newLectureNoteLastPage"
    }
  }, [_vm._v("Last PDF Page to Import")]), _vm._v(" "), _vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newLectureNoteLastPage),
      expression: "newLectureNoteLastPage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "id": "newLectureNoteLastPage",
      "placeholder": "Optional"
    },
    domProps: {
      "value": _vm._s(_vm.newLectureNoteLastPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newLectureNoteLastPage = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-md-3"
  }, [(!_vm.validPageNums) ? _vm._c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-top": "27px",
      "padding": "10px"
    }
  }, [_vm._v("Please enter valid values.")]) : _vm._e()])]) : (_vm.importType === 'pdf') ? _vm._c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._c('i', {
    staticClass: "fas fa-exclamation-triangle"
  }), _vm._v("   Please select or create a subject to continue")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('div', [(_vm.importType === 'pdf') ? _vm._c('h4', [_vm._c('b', [_vm._v("Importing to:")]), _vm._v(" " + _vm._s(_vm.newSubjectTitle || _vm.selectedSubjectTitle))]) : _vm._c('h4', [_vm._c('b', [_vm._v("Select an exported .CLEX file")])]), _vm._v(" "), (_vm.roundedUploadProgressPercentage > 0) ? _vm._c('div', {
    staticClass: "progress"
  }, [_vm._c('div', {
    staticClass: "progress-bar progress-bar-success progress-bar-striped active",
    style: ('width: ' + _vm.roundedUploadProgressPercentage + '%'),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.roundedUploadProgressPercentage,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.fileName) + " - \n                      "), (_vm.roundedUploadProgressPercentage == 100) ? _vm._c('span', [_vm._v("Processing...")]) : _vm._c('span', [_vm._v(" " + _vm._s(_vm.roundedUploadProgressPercentage) + "%")])])]) : _vm._c('Dropzone', {
    staticClass: "dropzone",
    attrs: {
      "id": "pdfUploadDropzone",
      "url": "https://httpbin.org/post",
      "autoProcessQueue": false,
      "useCustomDropzoneOptions": true,
      "dropzoneOptions": {
        'dictDefaultMessage': ('<div class="icon"><span class="mdi mdi-cloud-upload"></span></div><h3>Drag and drop import files here</h3><span class="note">(Or click anywhere to select files)</span>'),
        'acceptedFiles': 'application/pdf,.clex',
        'previewTemplate': '<span></span>',
      }
    },
    on: {
      "vdropzone-fileAdded": _vm.createLectureNote
    }
  })], 1)])])])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e8229b3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-importer/FileImporter.vue
// module id = 670
// module chunks = 1